import { MIX } from '../types';
export default {
  type: MIX,
  service: 'mix-blockchain.org',
  url: 'https://rpc2.mix-blockchain.org',
  port: 8647,
  auth: false,
  username: '',
  password: ''
};
